import React from 'react';
import PropTypes from 'prop-types';
import './Timeline.scss';

const Timeline = ({ data }) => (
  <div className="nw-timeline">
    {data && data.map((item, idx) => (
      <div key={idx}>
        <span style={{ left: `calc(${idx * 100 / (data.length - 1)}% - 9px)` }} className="nw-timeline__point" />
        {item.time && <span style={{ left: `${idx * 100 / (data.length - 1)}%` }} className="nw-timeline__time">{item.time}</span>}
      </div>
    ))}
  </div>
);

Timeline.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

Timeline.defaultProps = {
  data: [],
};

export default Timeline;
